module.exports = __webpack_public_path__ + "e26a29b0b695bea021258031967e4412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/5.jpg
// module id = 288
// module chunks = 0